import React, { createContext, useContext, useEffect, useState } from "react";
import { translations } from "./translations";

const I18nCtx = createContext(null);

export function I18nProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("ab_lang") || "it");
  useEffect(() => { localStorage.setItem("ab_lang", lang); }, [lang]);
  const t = translations[lang] || translations.it;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
